import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagos-separados',
  templateUrl: './pagos-separados.component.html',
  styleUrls: ['./pagos-separados.component.css']
})
export class PagosSeparadosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/pagos-separados/pagos-separados.component.ts